import {Component, Output, EventEmitter, Input, signal, inject, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import {CoreService} from '@services/core.service';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from '@app/material.module';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {AppSettings} from '@app/config';
import {MatDividerModule} from '@angular/material/divider';
import {navItemsSuperadmin} from '@core/data/sidebar/sidebar-superadmin-data';
import {NavItem} from '@interfaces/nav-item';
import {notifications} from '@interfaces/notifications';
import {profiledd} from '@interfaces/profiledd';
import {apps} from '@interfaces/apps';
import {environment} from '@environment/environment';
import {LogoutService} from '@services/api/logout/logout.service';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';
import {User} from '@interfaces/user';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    TranslateModule
  ],
  standalone: true,
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  private settings = inject(CoreService);
  private vsidenav = inject(CoreService);
  public dialog = inject(MatDialog);
  private translate = inject(TranslateService);

  private logout_service = inject(LogoutService);

  showFiller = false;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = environment.language_list;

  @Output() optionsChange = new EventEmitter<AppSettings>();
  private user_storage_service = inject(UserStorageService);
  protected user: User | null = null;
  private destroy$ = new Subject<void>();

  private readonly LANG_KEY = 'app_language';

  constructor() {
    this.translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.user_storage_service.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.user = user;
    });
    // Ripristina la lingua salvata
    const savedCode = localStorage.getItem(this.LANG_KEY);
    if (savedCode) {
      const lang = this.languages.find(l => l.code === savedCode);
      if (lang) {
        this.selectedLanguage = lang;
        this.translate.use(lang.code);
        this.settings.setLanguage(lang.code);
      }
    }
  }

  options = this.settings.getOptions();

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result: string | null | undefined) => {
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
    this.settings.setLanguage(lang.code);
    localStorage.setItem(this.LANG_KEY, lang.code);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  logout(){
    this.logout_service.logout();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  notifications: notifications[] = [];

  profiledd: profiledd[] = [];
  apps: apps[] = [];
}

@Component({
  selector: 'search-dialog',
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    MatDividerModule,
    TranslateModule,
  ],
  standalone: true,
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItemsSuperadmin;

  navItemsData = this.navItems.filter((navitem: any) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}

